import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitRoot } from '@cian/ui-kit';
import * as React from 'react';
import { Provider } from 'react-redux';
import { WithDialog } from '@cian/frontend-e2e-deal-component';

import { IApplicationContext } from '../../types/applicationContext';
import { IReduxStore } from '../../types/redux';
import { ApplicationContext } from '../../utils/applicationContext';
import { AuthenticationContainer } from '../AuthenticationContainer';
import { EPageMode } from '../../types/features';
import { PageWrapper } from '../../components/PageWrapper';
import { BecomeProfessionalContainer } from '../BecomeProfessionalContainer';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: IReduxStore;
}

const PAGES_BY_MODE: Record<EPageMode, React.FC> = {
  [EPageMode.Auth]: AuthenticationContainer,
  [EPageMode.BecomeProfessional]: BecomeProfessionalContainer,
};

export const Application: React.FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { initialDeviceType },
  } = context;

  const {
    page: { mode },
  } = reduxStore.getState();

  const Page = PAGES_BY_MODE[mode];

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitRoot deviceType={initialDeviceType}>
          <Provider store={reduxStore}>
            <WithDialog>
              <PageWrapper>
                <Page />
              </PageWrapper>
            </WithDialog>
          </Provider>
        </UiKitRoot>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
